export enum Platform {
  WebClient = 'WEBCLIENT',
}
